//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ModlUtils.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["faces","nLoops","loopList"],"GetFaceChainLoops",{},1,0],[["part"],"HasValidNonTimestampGeometriesInPart",{R_:{partHasNonTimestampGeometry:''}},1,0],[["object"],"IsNonTimestampCandidate",{R_:{isNonTimestampGeometry:''}},1,0],[["part","numObjects"],"FindValidNonTimestampGeometriesInPart",{R_:{nonTimestampObjects:"NXObject[]"}},1,0]],[]];
SPLM.ModlUtils.ModlUtilities = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ModlUtils.ModlUtilities";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;